import React from 'react';

export function ClubMapLegend() {
  return (
    <div
      className="club-map-legend"
      data-testid="club-map-legend"
      role="group"
      aria-label="Stand key"
    >
      <div className="club-map-legend__row">
        <span className="club-map-legend__swatch club-map-legend__swatch--open" />
        <span className="club-map-legend__label">OPEN</span>
      </div>
      <div className="club-map-legend__row">
        <span className="club-map-legend__swatch club-map-legend__swatch--on-stand" />
        <span className="club-map-legend__label">ON STAND</span>
      </div>
      <div className="club-map-legend__row">
        <span className="club-map-legend__swatch club-map-legend__swatch--reserved" />
        <span className="club-map-legend__label">RESERVED</span>
      </div>
      <div className="club-map-legend__row">
        <span className="club-map-legend__swatch club-map-legend__swatch--wind" />
        <span className="club-map-legend__label">WIND RIGHT</span>
      </div>
    </div>
  );
}
